import { ExZone, ExZoneType } from "@domain/project/floorplan/zones/ex-zone";
import { FloorplanItemTextKonva } from "@project/floorplanner/konva/floorplan-item-text-konva";
import { FloorplanWorkspaceKonvaAdapter } from "@project/floorplanner/konva/floorplan-workspace-konva.adapter";
import { ZoneKonva } from "@project/floorplanner/konva/zones/zone-konva";
import Konva from "konva";
import { Group } from "konva/lib/Group";
import { Rect } from "konva/lib/shapes/Rect";

export class ExZoneKonva {
  static init(exZone: ExZone): Group {
    let color: string = "";
    switch (exZone.exZoneType) {
      case ExZoneType.ZONE_0:
        color = "red";
        break;
      case ExZoneType.ZONE_1:
        color = "orange";
        break;
      case ExZoneType.ZONE_2:
        color = "yellow";
        break;
    }

    const parentGroup = new Group();

    const exZoneGroup = new Group({
      x: exZone.x,
      y: exZone.y,
      height: exZone.height,
      width: exZone.width,
      rotation: exZone.rotation,
      draggable: false,
    });

    const rect = new Rect({
      x: 0,
      y: 0,
      height: exZone.height,
      width: exZone.width,
      strokeEnabled: false,
      fill: color,
      opacity: 0.3,
    });

    const borderRect = new Konva.Rect({
      x: 0,
      y: 0,
      width: exZone.width,
      height: exZone.height,
      stroke: "#002766",
      strokeWidth: 4,
      fillEnabled: false,
      opacity: 1,
    });

    const itemText = FloorplanItemTextKonva.init(exZone);
    const text = FloorplanItemTextKonva.getText(itemText);
    ZoneKonva.setTextPosition(itemText, exZoneGroup);
    ZoneKonva.scaleText(text, exZoneGroup);

    exZoneGroup.on("transformstart", () => {
      itemText.hide();
    });

    exZoneGroup.on("transform", () => {
      exZoneGroup.width(Math.max(5, exZoneGroup.width() * exZoneGroup.scaleX()));
      exZoneGroup.height(Math.max(5, exZoneGroup.height() * exZoneGroup.scaleY()));

      rect.width(exZoneGroup.width());
      rect.height(exZoneGroup.height());
      borderRect.width(exZoneGroup.width());
      borderRect.height(exZoneGroup.height());

      exZoneGroup.scaleX(1);
      exZoneGroup.scaleY(1);
    });

    exZoneGroup.on("transformend", () => {
      exZone.updateForm(
        exZoneGroup.width() * exZoneGroup.scaleX(),
        exZoneGroup.height() * exZoneGroup.scaleY(),
        exZoneGroup.rotation(),
        exZoneGroup.x(),
        exZoneGroup.y(),
      );
      ZoneKonva.scaleText(text, exZoneGroup);
      ZoneKonva.setTextPosition(itemText, exZoneGroup);
      const labelHidden = itemText.getAttr("labelHidden") === true;
      if (!labelHidden) {
        itemText.show();
      }
    });

    exZoneGroup.on("dragmove", () => {
      ZoneKonva.setTextPosition(itemText, exZoneGroup);
    });

    exZoneGroup.setAttr(FloorplanWorkspaceKonvaAdapter.OBJECT_KEY, exZone);
    exZoneGroup.add(rect);
    exZoneGroup.add(borderRect);
    parentGroup.add(exZoneGroup, itemText);
    return parentGroup;
  }

  static refreshSize(exZone: ExZone, zoneGroup: Group) {
    ZoneKonva.resizeZoneGroup(zoneGroup, exZone.width, exZone.height);
    this.refreshItemText(exZone, zoneGroup);
  }

  static refreshItemText(exZone: ExZone, group: Group) {
    const text = group.getChildren()[1] as Group;
    const exZoneGroup = group.getChildren()[0] as Konva.Group;
    exZoneGroup.width(exZone.width);
    exZoneGroup.height(exZone.height);
    FloorplanItemTextKonva.refreshText(exZone, text);
    const textNode = FloorplanItemTextKonva.getText(text);
    ZoneKonva.scaleText(textNode, exZoneGroup);
    ZoneKonva.setTextPosition(text, exZoneGroup);
  }
}
